import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { useSendRequest } from '@/hooks/useFriends'
import type { Relation } from '@/api/friends'

/** DRF の ValidationError（文字列リスト）/ APIException（detail）双方からメッセージを拾う。 */
function requestErrorMessage(e: unknown): string {
  const data = (e as { response?: { data?: unknown } })?.response?.data
  if (Array.isArray(data) && typeof data[0] === 'string') return data[0]
  const detail = (data as { detail?: string } | undefined)?.detail
  return detail ?? 'フレンド申請に失敗しました'
}

type Props = {
  userId: number
  relation: Relation
}

/** 関係状態に応じた申請ボタン。検索・FoF一覧で共用。 */
export default function RequestButton({ userId, relation }: Props) {
  const send = useSendRequest()

  switch (relation) {
    case 'friend':
      return <Button size="sm" variant="outline" disabled>フレンド</Button>
    case 'pending_sent':
      return <Button size="sm" variant="outline" disabled>申請中</Button>
    case 'pending_received':
      return <Button size="sm" variant="outline" disabled>申請が届いています</Button>
    default:
      return (
        <Button
          size="sm"
          disabled={send.isPending}
          onClick={() =>
            send.mutate(userId, {
              onSuccess: () => toast.success('フレンド申請を送信しました'),
              onError: (e) => toast.error(requestErrorMessage(e)),
            })
          }
        >
          申請
        </Button>
      )
  }
}
